import { Translation } from 'hooks/useTranslation/useTranslation';
import { PageTabItems } from 'v2/components/PageTabs/PageTabs';

export const createDeviceTabs = (translation: Translation): PageTabItems => [
  {
    text: translation.all_devices,
    path: '/devices/overview'
  },
  {
    text: translation.device_groups,
    path: '/devices/groups'
  }
];
